import React from 'react';
import PropTypes, { any } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import PopupV3 from '../Popup/PopupV3';
import { dismissNotificationPopUp } from '../../actions/notification-actions';
import usePreRegistrationNotification from '../hooks/usePreRegistrationNotification';
import useIsMobile from '../hooks/useIsMobile';

const TOAST_POSITION_MOBILE = 'bottom-center';
const TOAST_POSITION_DEFAULT = 'top-right';

const Notifications = ({ currentRoute }) => {
    const notifications = useSelector(({ notifications }) => notifications);
    const dispatch = useDispatch();
    const { isMobileWidth } = useIsMobile();
    const toastPosition = isMobileWidth ? TOAST_POSITION_MOBILE : TOAST_POSITION_DEFAULT;

    const {
        popupV3 = {},
    } = notifications;

    const {
        title,
        message,
        noIcon,
        type,
        confirmButtonLabel,
        onConfirmClick,
        showCancelButton,
        showConfirmButton,
        showCloseButton,
        cancelButtonLabel,
        onCancelClick,
        onCloseButtonClick,
        showSupportLink,
        enableDoNotShowAgain,
        reverseButtonOrder,
    } = popupV3 || {};

    const handlePopupConfirmClick = (options) => {
        if (onConfirmClick) {
            onConfirmClick(options);
        }
        dispatch(dismissNotificationPopUp());
    };

    const handlePopupCancelClick = (options) => {
        if (onCancelClick) {
            onCancelClick(options);
        }
        dispatch(dismissNotificationPopUp());
    };

    const handlePopupCloseButtonClick = (options) => {
        if (onCloseButtonClick) {
            onCloseButtonClick(options);
            dispatch(dismissNotificationPopUp());
            return;
        }

        handlePopupCancelClick(options);
    };

    usePreRegistrationNotification(currentRoute);

    return (
        <>
            <ToastContainer
                position={toastPosition}
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
                icon={false}
            />
            <PopupV3
                title={title}
                message={message}
                noIcon={noIcon}
                type={type}
                isOpen={!!notifications?.popupV3}
                confirmButtonLabel={confirmButtonLabel || 'OK'}
                onConfirmClick={handlePopupConfirmClick}
                showCancelButton={showCancelButton}
                showConfirmButton={showConfirmButton}
                showCloseButton={showCloseButton}
                cancelButtonLabel={cancelButtonLabel || 'Cancel'}
                onCancelClick={handlePopupCancelClick}
                showSupportLink={showSupportLink}
                enableDoNotShowAgain={enableDoNotShowAgain}
                reverseButtonOrder={reverseButtonOrder}
                onCloseButtonClick={handlePopupCloseButtonClick}
                data-testid="modal.notification-popup"
            />
        </>
    );
};

Notifications.propTypes = {
    currentRoute: PropTypes.objectOf(any).isRequired,
};

export default Notifications;
